export enum QueryKeys {
  CATEGORIES = 'CATEGORIES',
  SECTIONS = 'SECTIONS',
  ARTICLES_IN_SECTION = 'ARTICLES_IN_SECTION',
  TOP_ARTICLES = 'TOP_ARTICLES',
}
